export default "__VITE_ASSET__C5P_b0Pq__"